module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-photo-6-fcee0361cc71dfdb74ee916a3431d83e.webp";